<div class="blotter_table_target find find-deals" (keydown)="altEnterSearch($event)">
  <div class="find-top-content-panels">
    <div #filterViewPane class="bfx-find-filter-view-panel visible" [hidden]="!filterViewShown">
      <p-tabView styleClass="bfx-tabview-primary-md bfx-tabview" #tv>
        <p-tabPanel header="Search" #tvSearch>
          <div class="bfx-find__filter-list" (scroll)="filterView.scrollHandler($event)">
            <bfx-find-deals-filter-view
              #filterView
              (selectSearch)="handleSelectSearch()"
            ></bfx-find-deals-filter-view>
            <div class="bfx-find__filter-list-spacer"></div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Favourites" #tvFav>
          <div class="bfx-find__favorite-list">
            <div *ngIf="favoriteData == null ||favoriteData.length==0" class="emptyMessage">
              {{favoriteEmptyMessage}}
            </div>
            <div *ngFor="let data of favoriteData" class="item">
              <div class="text" (click)="selectFavorite(data); tv.open(null,tvSearch);">
                {{data.filterName}}
              </div>
              <bfx-icon-button
                size="sm"
                iconClass="icon_ion_delete_filled"
                (action)="removeFavorite(data)"
                title="Delete"
                [tabindex]="1"
              ></bfx-icon-button>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>

    <div class="bfx-find-blotter-pane" attr.data-result-count="{{resultCount}}">
      <bfx-ladder-blotter-trade
        #embeddedBlotter
        [tableDefinitionFactory]="tableDefinitionFactory"
        [embeddedContextMenuService]="contextMenuService"
        [embeddedHideUnconfigured]="false"
        [embeddedTableModeSearchToggle]="true"
        [embeddedTableModeSuppressSelection]="false"
      ></bfx-ladder-blotter-trade>
    </div>
  </div>

  <div class="bfx-find-action-bar">
    <div class="bfx-find-button-pane bfx-find-button-pane-left">
      <button
        pButton
        #hideButton
        type="button"
        class="bfx-button-secondary-moderate bfx-button-toggle-pane"
        label="{{filterViewShown ? 'Hide' : 'Show'}}"
        icon="{{filterViewShown ? 'fa icon-ion_chevron_double_left' : 'fa icon-ion_chevron_double_right'}}"
        iconPos="{{filterViewShown ? 'left' : 'right'}}"
        [ngClass]="filterViewShown ? 'ui-button-text-icon-left' : 'ui-button-text-icon-right'"
        [tabindex]="2"
        (click)="toggleViewPane()"
      ></button>
      <button
        *ngIf="filterViewShown"
        class="bfx-button-secondary"
        #clearButton
        type="button"
        [tabindex]="3"
        label="Clear"
        [disabled]="!filterView.hasActiveRow || inProgress"
        (click)="handleClearClick()"
      >
        Clear
      </button>
      <button
        *ngIf="filterViewShown"
        class="bfx-button-primary"
        #searchButton1
        type="button"
        [disabled]="!filterView.hasActiveRow || inProgress"
        [tabindex]="2"
        label="Search"
        (click)="handleSearchClick()"
      >
        Search
      </button>
      <button
        *ngIf="filterViewShown"
        class="bfx-button-secondary"
        #saveButton
        type="button"
        [disabled]="!filterView.hasActiveRow || inProgress"
        [tabindex]="4"
        label="Save"
        (click)="handleSave()"
      >
        Save
      </button>
    </div>

    <div class="bfx-find-button-pane bfx-find-button-pane-right">
      <div>{{captionLabel}}</div>
      <button
        *ngIf="canExport"
        class="bfx-button-primary"
        #exportButton
        pButton
        type="button"
        [disabled]="resultCount == null || resultCount === 0 || embeddedBlotter == null || embeddedBlotter.selectedIdsCount == null || embeddedBlotter.selectedIdsCount == 0"
        [tabindex]="5"
        label="Export"
        (click)="handleExport()"
      ></button>
    </div>
  </div>
</div>

<bfx-find-deals-context-menu
  [currentLadderBlotter]="embeddedBlotter.blotterInstance"
  bfxElementOnBody
></bfx-find-deals-context-menu>
